import { gql } from '@apollo/client'

export const GET_INVITE_INFO = gql`
  query getInviteInfo {
    invitationForm {
      inviteCode
      bonus
      integral
      inviteRegisterCount
      invitedArtistCount
    }
  }
`

export const GET_INVITE_USER_LIST = gql`
  query getInviteUserList($first: Int, $offset: Int) {
    invitationList(page: { first: $first, offset: $offset }) {
      edges {
        node {
          inviteTime
          inviteType
          nickName
          user {
            avatarUrl
            base {
              uid
            }
          }
        }
      }
      pageInfo {
        totalCount
        hasNextPage
      }
    }
  }
`

export const GET_INVITE_BONUS_LIST = gql`
  query getInviteBonusList($type: InviteBonusType, $first: Int, $offset: Int) {
    inviteBonusDetailList(
      inviteBonusType: $type
      page: { first: $first, offset: $offset }
    ) {
      edges {
        node {
          bonus
          bonusType
          desc
          id
          time
          user {
            avatarUrl
            base {
              uid
            }
          }
        }
      }
      pageInfo {
        totalCount
        hasNextPage
      }
    }
  }
`
